/* Enhances the existing Complimus form; the app owns storage and transactional mail. */
(() => {
  if (window.hapsWithdrawalLoaded) return;
  window.hapsWithdrawalLoaded = true;
  let receipt = null;
  let serverDate = null;
  const originalFetch = window.fetch;
  // Preserve the app response unchanged and use its server time for the receipt view.
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0] instanceof Request ? args[0].url : String(args[0]);
    const root = document.querySelector('.complimus-withdrawal[data-endpoint]');
    if (root && new URL(url, location.href).pathname === root.dataset.endpoint && response.ok) {
      serverDate = response.headers.get('Date');
      try {
        const data = await response.clone().json();
        const entry = data.withdrawal || data.request || data.data || data;
        receipt = entry.submittedAt || entry.submitted_at || entry.receivedAt || entry.received_at || entry.createdAt || entry.created_at || null;
        console.info('HAPS withdrawal receipt metadata', { keys: Object.keys(data), entryKeys: Object.keys(entry), timestamp: receipt, serverDate });
      } catch { /* The native app remains responsible for response handling. */ }
    }
    return response;
  };

  function enhance(root) {
    const form = root.querySelector('[data-cw-form]');
    if (!form || root.dataset.hapsReady) return;
    if (root.dataset.askItems === 'true' && !form.querySelector('[data-cw-item]')) return;
    root.dataset.hapsReady = 'true';
    const submit = form.querySelector('[data-cw-submit]');
    const items = form.querySelector('[data-cw-items]');
    const first = items?.querySelector('[data-cw-item]');
    const name = form.elements.namedItem('name');
    const label = name && form.querySelector(`label[for="${name.id}"]`);
    if (label) label.textContent = 'Vor- und Nachname';
    submit.textContent = 'Angaben prüfen';
    const progress = document.createElement('p');
    progress.className = 'haps-withdrawal-step';
    progress.textContent = 'Schritt 1 von 2 · Angaben eingeben';
    form.prepend(progress);

    let scope = null;
    let whole = false;
    let savedFirst = null;
    let detached = [];
    if (items && first) {
      const id = `${root.id}-scope`;
      const field = document.createElement('div');
      field.className = 'cw-field';
      field.innerHTML = `<label for="${id}">Umfang des Widerrufs</label><select id="${id}" name="hapsScope"><option value="whole">Gesamte Bestellung</option><option value="partial">Einzelne Artikel</option></select>`;
      items.before(field);
      scope = field.querySelector('select');
      const changeScope = () => {
        whole = scope.value === 'whole';
        const title = first.querySelector('[name="title"]');
        const variant = first.querySelector('[name="variant"]');
        const quantity = first.querySelector('[name="quantity"]');
        if (whole && !savedFirst) {
          savedFirst = [title.value, variant.value, quantity.value];
          detached = Array.from(items.querySelectorAll('[data-cw-item]')).slice(1);
          detached.forEach(row => row.remove());
          title.value = 'Gesamte Bestellung';
          variant.value = '';
          quantity.value = '1';
        } else if (!whole && savedFirst) {
          [title.value, variant.value, quantity.value] = savedFirst;
          detached.forEach(row => items.querySelector('[data-cw-item-list]').append(row));
          savedFirst = null;
          detached = [];
        }
        items.hidden = whole;
      };
      scope.addEventListener('change', changeScope);
      changeScope();
    }

    const review = document.createElement('section');
    review.className = 'haps-withdrawal-review';
    review.hidden = true;
    const reviewTitle = document.createElement('h2');
    reviewTitle.textContent = 'Widerruf prüfen und bestätigen';
    reviewTitle.tabIndex = -1;
    const reviewStep = document.createElement('p');
    reviewStep.className = 'haps-withdrawal-step';
    reviewStep.textContent = 'Schritt 2 von 2 · Angaben prüfen';
    const declaration = document.createElement('p');
    declaration.textContent = 'Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über den Kauf der folgenden Waren.';
    const summary = document.createElement('dl');
    const notice = document.createElement('p');
    notice.textContent = 'Erst mit dem folgenden Bestätigungsklick wird Ihr Widerruf übermittelt.';
    const actions = document.createElement('div');
    actions.className = 'haps-withdrawal-actions';
    const edit = document.createElement('button');
    edit.type = 'button';
    edit.className = 'button button--secondary';
    edit.textContent = 'Angaben ändern';
    const confirm = document.createElement('button');
    confirm.type = 'button';
    confirm.className = 'button button--primary';
    confirm.textContent = 'Widerruf jetzt bestätigen';
    actions.append(edit, confirm);
    review.append(reviewStep, reviewTitle, declaration, summary, notice, actions);
    form.after(review);
    const add = (key, value) => {
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      dt.textContent = key;
      dd.textContent = value;
      summary.append(dt, dd);
    };
    let permitSubmit = false;
    form.addEventListener('submit', event => {
      if (permitSubmit) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      for (const key of ['name', 'email', 'orderNumber']) {
        const input = form.elements.namedItem(key);
        if (input) input.value = input.value.trim();
      }
      if (!form.reportValidity()) return;
      summary.replaceChildren();
      add('Vor- und Nachname', name.value);
      add('Bestellnummer', form.elements.namedItem('orderNumber').value);
      add('E-Mail für die Bestätigung', form.elements.namedItem('email').value);
      add('Umfang', whole || !items ? 'Gesamte Bestellung' : 'Einzelne Artikel');
      if (items && !whole) {
        const lines = Array.from(items.querySelectorAll('[data-cw-item]')).map(row => {
          const title = row.querySelector('[name="title"]').value;
          const variant = row.querySelector('[name="variant"]').value;
          const quantity = row.querySelector('[name="quantity"]').value;
          return `${quantity} × ${title}${variant ? ` – ${variant}` : ''}`;
        });
        add('Artikel', lines.join('\n'));
      }
      const message = form.elements.namedItem('message')?.value;
      if (message) add('Freiwillige Nachricht', message);
      form.hidden = true;
      review.hidden = false;
      reviewTitle.focus();
    }, true);
    edit.addEventListener('click', () => {
      review.hidden = true;
      form.hidden = false;
      name.focus();
    });
    confirm.addEventListener('click', () => {
      if (confirm.disabled) return;
      confirm.disabled = true;
      review.hidden = true;
      form.hidden = false;
      permitSubmit = true;
      submit.textContent = 'Widerruf jetzt bestätigen';
      form.requestSubmit(submit);
      permitSubmit = false;
    });

    const observer = new MutationObserver(() => {
      const done = root.querySelector('[data-cw-done]');
      if (done && !done.hidden && !done.querySelector('[data-haps-receipt]')) {
        const p = document.createElement('p');
        p.dataset.hapsReceipt = 'true';
        const time = new Date(receipt || serverDate || Date.now());
        const prefix = receipt ? 'Eingang: ' : serverDate ? 'Vom Server bestätigt: ' : 'Eingangsbestätigung angezeigt: ';
        p.textContent = prefix + new Intl.DateTimeFormat('de-DE', { dateStyle: 'long', timeStyle: 'long', timeZone: 'Europe/Berlin' }).format(time);
        done.append(p);
        const title = document.createElement('h2');
        title.textContent = 'Ihr Widerruf ist eingegangen';
        title.tabIndex = -1;
        done.prepend(title);
        title.focus();
        confirm.disabled = true;
      }
      const error = root.querySelector('[data-cw-form-error]');
      if (error && !error.hidden && error.textContent.trim()) {
        confirm.disabled = false;
        submit.textContent = 'Angaben prüfen';
      }
    });
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  }
  function start() {
    document.querySelectorAll('.complimus-withdrawal[data-endpoint]').forEach(enhance);
  }
  function boot() {
    start();
    const pending = new MutationObserver(() => {
      start();
      const roots = Array.from(document.querySelectorAll('.complimus-withdrawal[data-endpoint]'));
      if (roots.length && roots.every(root => root.dataset.hapsReady)) pending.disconnect();
    });
    pending.observe(document.body, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', start);
})();
